import React from 'react';
import { AbsoluteFill, useCurrentFrame, interpolate } from 'remotion';

export const HealthTipsAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  
  const tips = [
    { icon: '💧', title: '多喝水', desc: '每天8杯水' },
    { icon: '🏃', title: '多运动', desc: '每周3次' },
    { icon: '😴', title: '早睡觉', desc: '晚上11点前' },
  ];

  return (
    <AbsoluteFill style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: 80,
      color: 'white',
    }}>
      <h1 style={{ fontSize: 70, textAlign: 'center', marginBottom: 60 }}>
        健康小贴士 💪
      </h1>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>
        {tips.map((tip, i) => {
          const delay = i * 20;
          const opacity = interpolate(frame, [delay, delay + 15], [0, 1], { extrapolateRight: 'clamp' });
          const x = interpolate(frame, [delay, delay + 20], [-100, 0], { extrapolateRight: 'clamp' });
          
          return (
            <div key={i} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 30,
              padding: 30,
              background: 'rgba(255,255,255,0.1)',
              borderRadius: 20,
              opacity,
              transform: `translateX(${x}px)`,
            }}>
              <span style={{ fontSize: 60 }}>{tip.icon}</span>
              <div>
                <h3 style={{ fontSize: 40, margin: 0 }}>{tip.title}</h3>
                <p style={{ fontSize: 24, margin: 0, opacity: 0.8 }}>{tip.desc}</p>
              </div>
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};
